export const dictionaries: { [key: string]: { [key: string]: string } } = {
  xyp_cpl0001: {
    '1': '0-9家',
    '2': '9-14家',
    '3': '大于 14 家',
  },
  xyp_cpl0002: {
    '1': '0-5家',
    '2': '5-9家',
    '3': '9-14家',
    '4': '14-17家',
    '5': '大于 17 家',
  },
  xyp_cpl0007: {
    '1': '0-1家',
    '2': '1-2家',
    '3': '2-4家',
    '4': '大于 4 家',
  },
  xyp_cpl0008: {
    '1': '0-1家',
    '2': '1-5家',
    '3': '5-11家',
    '4': '大于 11 家',
  },
  xyp_cpl0070: {
    '1': '0-1家',
    '2': '1-3家',
    '3': '大于 3 家',
  },
  xyp_cpl0009: {
    '1': '0-1家',
    '2': '1-9家',
    '3': '大于 9 家',
  },
  xyp_cpl0010: {
    '1': '0-1家',
    '2': '1-3家',
    '3': '3-10家',
    '4': '大于 10 家',
  },
  xyp_cpl0063: {
    '1': '0-3家',
    '2': '3-6家',
    '3': '6-11家',
    '4': '大于 11 家',
  },
  xyp_cpl0011: {
    '1': '0-1家',
    '2': '1-4家',
    '3': '4-11家',
    '4': '大于 11 家',
  },
  xyp_cpl0012: {
    '1': '0-5家',
    '2': '5-10家',
    '3': '10-17家',
    '4': '大于 17 家',
  },
  xyp_cpl0013: {
    '1': '0-4家',
    '2': '4-7家',
    '3': '7-13家',
    '4': '大于 13 家',
  },
  xyp_cpl0014: {
    '1': '0-2笔',
    '2': '2-10笔',
    '3': '10-34笔',
    '4': '34-60笔',
    '5': '大于 60 笔',
  },
  xyp_cpl0015: {
    '1': '0-3笔',
    '2': '3-5笔',
    '3': '5-10笔',
    '4': '大于 10 笔',
  },
  xyp_cpl0016: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '大于 5 家',
  },
  xyp_cpl0017: {
    '1': '0-3家',
    '2': '大于 3 家',
  },
  xyp_cpl0018: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-7家',
    '4': '大于 7 家',
  },
  xyp_cpl0019: {
    '1': '0-3家',
    '2': '3-13家',
    '3': '大于 13 家',
  },
  xyp_cpl0020: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-15家',
    '4': '大于 15 家',
  },
  xyp_cpl0021: {
    '1': '0-5家',
    '2': '5-21家',
    '3': '大于 21 家',
  },
  xyp_cpl0064: {
    '1': '0-5家',
    '2': '5-27家',
    '3': '大于 27 家',
  },
  xyp_cpl0065: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-20家',
    '4': '大于 20 家',
  },
  xyp_cpl0022: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-34家',
    '4': '大于 34 家',
  },
  xyp_cpl0023: {
    '1': '0-7家',
    '2': '7-34家',
    '3': '大于 34 家',
  },
  xyp_cpl0024: {
    '1': '0-6家',
    '2': '6-22家',
    '3': '22-56家',
    '4': '大于 56 家',
  },
  xyp_cpl0025: {
    '1': '0-2家',
    '2': '2-31家',
    '3': '大于 31 家',
  },
  xyp_cpl0026: {
    '1': '0-3家',
    '2': '3-25家',
    '3': '25-30家',
    '4': '30-70家',
    '5': '大于 70 家',
  },
  xyp_cpl0027: {
    '1': '0-3家',
    '2': '3-27家',
    '3': '27-50家',
    '4': '大于 50 家',
  },
  xyp_cpl003Mgr: {
    '1': '0-1500家',
    '2': '1500-2500家',
    '3': '2500-5000家',
    '4': '大于 5000 家',
  },
  xyp_cpl0033: {
    '1': '0-1500家',
    '2': '1500-5000家',
    '3': '大于 5000 家',
  },
  xyp_cpl0034: {
    '1': '0-2000家',
    '2': '2000-10000家',
    '3': '10000-17000家',
    '4': '17000-26000家',
    '5': '大于 26000 家',
  },
  xyp_cpl0035: {
    '1': '0-2000家',
    '2': '2000-17000家',
    '3': '大于 17000 家',
  },
  xyp_cpl0036: {
    '1': '0-1000家',
    '2': '1000-4000家',
    '3': '4000-9000家',
    '4': '9000-30000家',
    '5': '大于 30000 家',
  },
  xyp_cpl0037: {
    '1': '0-9000家',
    '2': '9000-31000家',
    '3': '大于 31000 家',
  },
  xyp_cpl0066: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '2000-30000家',
    '4': '30000-50000家',
    '5': '大于 50000 家',
  },
  xyp_cpl0067: {
    '1': '0-1000家',
    '2': '1000-34000家',
    '3': '大于 34000 家',
  },
  xyp_cpl0038: {
    '1': '0-6000家',
    '2': '6000-10000家',
    '3': '10000-50000家',
    '4': '大于 50000 家',
  },
  xyp_cpl0039: {
    '1': '0-10000家',
    '2': '10000-36000家',
    '3': '大于 36000 家',
  },
  xyp_cpl0040: {
    '1': '0-10000家',
    '2': '10000-50000家',
    '3': '50000-80000家',
    '4': '大于 80000 家',
  },
  xyp_cpl0041: {
    '1': '0-13000家',
    '2': '13000-49000家',
    '3': '大于 49000 家',
  },
  xyp_cpl0042: {
    '1': '0-2000家',
    '2': '2000-30000家',
    '3': '30000-60000家',
    '4': '60000-90000家',
    '5': '大于 90000 家',
  },
  xyp_cpl0043: {
    '1': '0-2000家',
    '2': '2000-58000家',
    '3': '大于 58000 家',
  },
  xyp_cpl0045: {
    '1': '0-220家',
    '2': '220-450家',
    '3': '450-520家',
    '4': '大于 520 家',
  },
  xyp_cpl0046: {
    '1': '0-5家',
    '2': '5-25家',
    '3': '大于 25 家',
  },
  xyp_cpl0048: {
    '1': '0-1家',
    '2': '1-2家',
    '3': '大于 2 家',
  },
  xyp_cpl0049: {
    '1': '0-1家',
    '2': '1-3家',
    '3': '大于 3 家',
  },
  xyp_cpl0050: {
    '1': '0-1家',
    '2': '1-3家',
    '3': '大于 3 家',
  },
  xyp_cpl0051: {
    '1': '0-1家',
    '2': '1-3家',
    '3': '大于 3 家',
  },
  xyp_cpl0052: {
    '1': '0-1',
    '2': '1-2',
    '3': '2-4',
    '4': '大于 4',
  },
  xyp_cpl0053: {
    '1': '0-1',
    '2': '1-2',
    '3': '2-4',
    '4': '4-10',
    '5': '大于 10',
  },
  xyp_cpl0069: {
    '1': '0-2',
    '2': '2-4',
    '3': '4-10',
    '4': '大于 10',
  },
  xyp_cpl0054: {
    '1': '0-14家',
    '2': '大于 14 家',
  },
  xyp_cpl0055: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-8家',
    '4': '8-10家',
    '5': '10-15家',
    '6': '15-20家',
    '7': '20-30家',
    '8': '30-50家',
    '9': '50-100家',
    '10': '100-200家',
    '11': '200-500家',
    '12': '500-1000家',
    '13': '大于 1000 家',
  },
  xyp_cpl0056: {
    '1': '0-5',
    '2': '5-20',
    '3': '20-35',
    '4': '大于 35',
  },
  xyp_cpl0057: {
    '1': '0-1家',
    '2': '大于 1 家',
  },
  xyp_cpl0058: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-8家',
    '4': '8-10家',
    '5': '10-15家',
    '6': '15-20家',
    '7': '20-30家',
    '8': '30-50家',
    '9': '50-100家',
    '10': '100-200家',
    '11': '200-500家',
    '12': '500-1000家',
    '13': '大于 1000 家',
  },
  xyp_cpl0059: {
    '1': '0-10家',
    '2': '大于 10 家',
  },
  xyp_cpl0060: {
    '1': '0-5家',
    '2': '大于 5 家',
  },
  xyp_cpl0061: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-8家',
    '4': '8-10家',
    '5': '10-15家',
    '6': '15-20家',
    '7': '20-30家',
    '8': '30-50家',
    '9': '50-100家',
    '10': '100-200家',
    '11': '200-500家',
    '12': '500-1000家',
    '13': '大于 1000 家',
  },
  xyp_cpl0062: {
    '1': '0-1',
    '2': '1-2',
    '3': '2-36',
    '4': '大于 36',
  },
  xyp_cpl0068: {
    '1': '0-5家',
    '2': '5-50家',
    '3': '50-160家',
    '4': '大于 160 家',
  },
  xyp_cpl0071: {
    '1': '1-2家',
    '2': '2-4家',
    '3': '大于 4 家',
  },
  xyp_cpl0072: {
    '1': '0-1000元',
    '2': '1000-2000元',
    '3': '2000-3000元',
    '4': '3000-5000元',
    '5': '5000-7000元',
    '6': '7000-11000元',
    '7': '大于 11000 元',
  },
  xyp_cpl0076: {
    '1': '0-2家',
    '2': '2-11家',
    '3': '11-13家',
    '4': '大于 13 家',
  },
  xyp_cpl0077: {
    '1': '0-4000家',
    '2': '4000-8000家',
    '3': '大于 8000 家',
  },
  xyp_cpl0078: {
    '1': '0-2000家',
    '2': '2000-25000家',
    '3': '大于 25000 家',
  },
  xyp_t01aabzbz: {
    '1': '0-1000家',
    '2': '1000-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01aadzbz: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aaezbc: {
    '1': '0-1000家',
    '2': '1000-1400家',
    '3': '大于 1400 家',
  },
  xyp_t01aafzbc: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aafzbz: {
    '1': '0-1000家',
    '2': '1000-4200家',
    '3': '大于 4200 家',
  },
  xyp_t01aafzzc: {
    '1': '0-600家',
    '2': '600-1000家',
    '3': '大于 1000 家',
  },
  xyp_t01aafzzz: {
    '1': '0-400家',
    '2': '400-1000家',
    '3': '大于 1000 家',
  },
  xyp_t01aagzaz: {
    '1': '0-1000家',
    '2': '1000-2300家',
    '3': '大于 2300 家',
  },
  xyp_t01aagzbz: {
    '1': '0-1000家',
    '2': '1000-4600家',
    '3': '大于 4600 家',
  },
  xyp_t01aagzzc: {
    '1': '0-1000家',
    '2': '1000-4800家',
    '3': '大于 4800 家',
  },
  xyp_t01aahzbz: {
    '1': '0-1000家',
    '2': '1000-4800家',
    '3': '大于 4800 家',
  },
  xyp_t01aahzza: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aaizba: {
    '1': '0-1000家',
    '2': '1000-1800家',
    '3': '大于 1800 家',
  },
  xyp_t01aaizbz: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aaizzc: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aaizzz: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aajzba: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aajzza: {
    '1': '0-1000家',
    '2': '1000-1400家',
    '3': '大于 1400 家',
  },
  xyp_t01aajzzc: {
    '1': '0-2000家',
    '2': '2000-4200家',
    '3': '大于 4200 家',
  },
  xyp_t01aakzba: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aakzzz: {
    '1': '0-1000家',
    '2': '1000-4600家',
    '3': '大于 4600 家',
  },
  xyp_t01aalzbc: {
    '1': '0-1000家',
    '2': '1000-4600家',
    '3': '大于 4600 家',
  },
  xyp_t01aalzbz: {
    '1': '0-1000家',
    '2': '1000-4600家',
    '3': '大于 4600 家',
  },
  xyp_t01aalzzc: {
    '1': '0-1000家',
    '2': '1000-4600家',
    '3': '大于 4600 家',
  },
  xyp_t01aalzzz: {
    '1': '0-1000家',
    '2': '1000-4600家',
    '3': '大于 4600 家',
  },
  xyp_t01aazzzc: {
    '1': '0-1000家',
    '2': '1000-4800家',
    '3': '大于 4800 家',
  },
  xyp_t01abdzbz: {
    '1': '0-500家',
    '2': '500-1300家',
    '3': '大于 1300 家',
  },
  xyp_t01abezbz: {
    '1': '0-500家',
    '2': '500-1300家',
    '3': '大于 1300 家',
  },
  xyp_t01abfzba: {
    '1': '0-300家',
    '2': '300-1300家',
    '3': '大于 1300 家',
  },
  xyp_t01abfzbz: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01abfzza: {
    '1': '0-600家',
    '2': '600-1300家',
    '3': '大于 1300 家',
  },
  xyp_t01abfzzc: {
    '1': '0-50家',
    '2': '50-450家',
    '3': '大于 450 家',
  },
  xyp_t01abfzzz: {
    '1': '0-50家',
    '2': '50-450家',
    '3': '大于 450 家',
  },
  xyp_t01abgzbc: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01abgzzc: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01abhzbc: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01abizbz: {
    '1': '0-200家',
    '2': '200-500家',
    '3': '大于 500 家',
  },
  xyp_t01abizzc: {
    '1': '0-200家',
    '2': '200-650家',
    '3': '650-1950家',
    '4': '大于 1950 家',
  },
  xyp_t01abjzbc: {
    '1': '0-50家',
    '2': '50-200家',
    '3': '200-500家',
    '4': '大于 500 家',
  },
  xyp_t01abjzzc: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '100-200家',
    '4': '大于 200 家',
  },
  xyp_t01abkzba: {
    '1': '0-1000家',
    '2': '1000-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01abkzbc: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '100-450家',
    '4': '大于 450 家',
  },
  xyp_t01abkzbz: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01abkzza: {
    '1': '0-600家',
    '2': '600-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01ablzbc: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01abzzza: {
    '1': '0-600家',
    '2': '600-1300家',
    '3': '大于 1300 家',
  },
  xyp_t01acbzzz: {
    '1': '0-11000家',
    '2': '11000-26000家',
    '3': '大于 26000 家',
  },
  xyp_t01acczzz: {
    '1': '0-1000家',
    '2': '1000-36000家',
    '3': '大于 36000 家',
  },
  xyp_t01acdzbz: {
    '1': '0-1000家',
    '2': '1000-34000家',
    '3': '大于 34000 家',
  },
  xyp_t01acdzzz: {
    '1': '0-2000家',
    '2': '2000-52000家',
    '3': '大于 52000 家',
  },
  xyp_t01acezba: {
    '1': '0-3000家',
    '2': '3000-8000家',
    '3': '大于 8000 家',
  },
  xyp_t01acezbz: {
    '1': '0-6000家',
    '2': '6000-54000家',
    '3': '大于 54000 家',
  },
  xyp_t01acezzz: {
    '1': '0-6000家',
    '2': '6000-52000家',
    '3': '大于 52000 家',
  },
  xyp_t01acfzbc: {
    '1': '0-12000家',
    '2': '12000-40000家',
    '3': '大于 40000 家',
  },
  xyp_t01acfzbz: {
    '1': '0-10000家',
    '2': '10000-42000家',
    '3': '大于 42000 家',
  },
  xyp_t01acfzza: {
    '1': '0-3000家',
    '2': '3000-18000家',
    '3': '大于 18000 家',
  },
  xyp_t01acgzbc: {
    '1': '0-2000家',
    '2': '2000-46000家',
    '3': '大于 46000 家',
  },
  xyp_t01acgzza: {
    '1': '0-1000家',
    '2': '1000-18000家',
    '3': '大于 18000 家',
  },
  xyp_t01acgzzz: {
    '1': '0-26000家',
    '2': '26000-92000家',
    '3': '大于 92000 家',
  },
  xyp_t01achzaz: {
    '1': '0-1000家',
    '2': '1000-3000家',
    '3': '大于 3000 家',
  },
  xyp_t01achzbc: {
    '1': '0-2000家',
    '2': '2000-42000家',
    '3': '大于 42000 家',
  },
  xyp_t01achzbz: {
    '1': '0-6000家',
    '2': '6000-30000家',
    '3': '大于 30000 家',
  },
  xyp_t01achzzc: {
    '1': '0-4000家',
    '2': '4000-64000家',
    '3': '大于 64000 家',
  },
  xyp_t01acizba: {
    '1': '0-1000家',
    '2': '1000-3200家',
    '3': '大于 3200 家',
  },
  xyp_t01acizbc: {
    '1': '0-3000家',
    '2': '3000-5500家',
    '3': '大于 5500 家',
  },
  xyp_t01acizbz: {
    '1': '0-2000家',
    '2': '2000-7500家',
    '3': '大于 7500 家',
  },
  xyp_t01acizza: {
    '1': '0-1000家',
    '2': '1000-3200家',
    '3': '大于 3200 家',
  },
  xyp_t01acizzz: {
    '1': '0-3000家',
    '2': '3000-8000家',
    '3': '大于 8000 家',
  },
  xyp_t01acjzaz: {
    '1': '0-1500家',
    '2': '1500-3000家',
    '3': '大于 3000 家',
  },
  xyp_t01acjzba: {
    '1': '0-3000家',
    '2': '3000-9000家',
    '3': '大于 9000 家',
  },
  xyp_t01acjzbc: {
    '1': '0-13000家',
    '2': '13000-19000家',
    '3': '大于 19000 家',
  },
  xyp_t01acjzbz: {
    '1': '0-7000家',
    '2': '7000-26000家',
    '3': '大于 26000 家',
  },
  xyp_t01acjzzz: {
    '1': '0-10000家',
    '2': '10000-34000家',
    '3': '大于 34000 家',
  },
  xyp_t01ackzaz: {
    '1': '0-1000家',
    '2': '1000-3000家',
    '3': '大于 3000 家',
  },
  xyp_t01ackzbz: {
    '1': '0-24000家',
    '2': '24000-64000家',
    '3': '大于 64000 家',
  },
  xyp_t01ackzza: {
    '1': '0-3000家',
    '2': '3000-19000家',
    '3': '大于 19000 家',
  },
  xyp_t01ackzzc: {
    '1': '0-2000家',
    '2': '2000-14000家',
    '3': '大于 14000 家',
  },
  xyp_t01ackzzz: {
    '1': '0-30000家',
    '2': '30000-70000家',
    '3': '大于 70000 家',
  },
  xyp_t01aclzbc: {
    '1': '0-2000家',
    '2': '2000-42000家',
    '3': '大于 42000 家',
  },
  xyp_t01aclzbz: {
    '1': '0-36000家',
    '2': '36000-104000家',
    '3': '大于 104000 家',
  },
  xyp_t01aclzzc: {
    '1': '0-14000家',
    '2': '14000-64000家',
    '3': '大于 64000 家',
  },
  xyp_t01aclzzz: {
    '1': '0-10000家',
    '2': '10000-45000家',
    '3': '大于 45000 家',
  },
  xyp_t01aczzaz: {
    '1': '0-3000家',
    '2': '3000-27000家',
    '3': '大于 27000 家',
  },
  xyp_t01aczzbc: {
    '1': '0-12000家',
    '2': '12000-54000家',
    '3': '大于 54000 家',
  },
  xyp_t01aczzzc: {
    '1': '0-14000家',
    '2': '14000-68000家',
    '3': '大于 68000 家',
  },
  xyp_t01aczzzz: {
    '1': '0-45000家',
    '2': '45000-115000家',
    '3': '大于 115000 家',
  },
  xyp_t01adczbz: {
    '1': '0-600家',
    '2': '600-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01addzbz: {
    '1': '0-600家',
    '2': '600-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adfzbz: {
    '1': '0-600家',
    '2': '600-1400家',
    '3': '大于 1400 家',
  },
  xyp_t01adfzza: {
    '1': '0-500家',
    '2': '500-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adfzzc: {
    '1': '0-600家',
    '2': '600-1800家',
    '3': '大于 1800 家',
  },
  xyp_t01adfzzz: {
    '1': '0-700家',
    '2': '700-1800家',
    '3': '大于 1800 家',
  },
  xyp_t01adgzba: {
    '1': '0-300家',
    '2': '300-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01adgzbc: {
    '1': '0-600家',
    '2': '600-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01adgzza: {
    '1': '0-400家',
    '2': '400-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adgzzc: {
    '1': '0-600家',
    '2': '600-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01adhzbc: {
    '1': '0-600家',
    '2': '600-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01adizbc: {
    '1': '0-300家',
    '2': '300-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01adizbz: {
    '1': '0-700家',
    '2': '700-1500家',
    '3': '大于 1500 家',
  },
  xyp_t01adizzc: {
    '1': '0-1600家',
    '2': '700-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01adjzba: {
    '1': '0-300家',
    '2': '300-1300家',
    '3': '大于 1300 家',
  },
  xyp_t01adjzbc: {
    '1': '0-1300家',
    '2': '1300-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adjzzc: {
    '1': '0-1300家',
    '2': '1300-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adjzzz: {
    '1': '0-700家',
    '2': '700-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adkzbc: {
    '1': '0-1300家',
    '2': '1300-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adkzzc: {
    '1': '0-600家',
    '2': '600-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adlzzc: {
    '1': '0-600家',
    '2': '600-1700家',
    '3': '大于 1700 家',
  },
  xyp_t01adzzba: {
    '1': '0-300家',
    '2': '300-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01bazzba: {
    '1': '0-50家',
    '2': '50-90家',
    '3': '90-180家',
    '4': '180-420家',
    '5': '大于 420 家',
  },
  xyp_t01bazzbc: {
    '1': '0-220家',
    '2': '220-350家',
    '3': '350-440家',
    '4': '440-500家',
    '5': '大于 500 家',
  },
  xyp_t01bazzbz: {
    '1': '0-220家',
    '2': '220-350家',
    '3': '350-450家',
    '4': '450-500家',
    '5': '大于 500 家',
  },
  xyp_t01bazzza: {
    '1': '0-50家',
    '2': '50-180家',
    '3': '180-280家',
    '4': '280-400家',
    '5': '大于 400 家',
  },
  xyp_t01bazzzc: {
    '1': '0-220家',
    '2': '220-350家',
    '3': '350-450家',
    '4': '450-520家',
    '5': '大于 520 家',
  },
  xyp_t01bbzzaz: {
    '1': '0-10家',
    '2': '10-40家',
    '3': '40-200家',
    '4': '大于 200 家',
  },
  xyp_t01bbzzba: {
    '1': '0-10家',
    '2': '10-30家',
    '3': '30-150家',
    '4': '大于 150 家',
  },
  xyp_t01bbzzbc: {
    '1': '0-5家',
    '2': '5-50家',
    '3': '50-160家',
    '4': '大于 160 家',
  },
  xyp_t01bbzzbz: {
    '1': '0-5家',
    '2': '5-25家',
    '3': '25-50家',
    '4': '50-150家',
    '5': '大于 150 家',
  },
  xyp_t01bbzzza: {
    '1': '0-5家',
    '2': '5-25家',
    '3': '25-50家',
    '4': '50-115家',
    '5': '大于 115 家',
  },
  xyp_t01ccbzbz: {
    '1': '0-3家',
    '2': '3-6家',
    '3': '6-13家',
    '4': '大于 13 家',
  },
  xyp_t01ccbzzz: {
    '1': '0-3家',
    '2': '3-7家',
    '3': '7-15家',
    '4': '大于 15 家',
  },
  xyp_t01ccczza: {
    '1': '0-3家',
    '2': '大于 3 家',
  },
  xyp_t01ccezzz: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-34家',
    '4': '大于 34 家',
  },
  xyp_t01ccfzbc: {
    '1': '0-2家',
    '2': '2-10家',
    '3': '10-20家',
    '4': '大于 20 家',
  },
  xyp_t01ccfzzz: {
    '1': '0-6家',
    '2': '6-22家',
    '3': '22-56家',
    '4': '大于 56 家',
  },
  xyp_t01ccgzbc: {
    '1': '0-2家',
    '2': '2-4家',
    '3': '4-33家',
    '4': '大于 33 家',
  },
  xyp_t01ccgzza: {
    '1': '0-3家',
    '2': '3-5家',
    '3': '5-15家',
    '4': '大于 15 家',
  },
  xyp_t01ccgzzz: {
    '1': '0-24家',
    '2': '24-38家',
    '3': '38-74家',
    '4': '大于 74 家',
  },
  xyp_t01cchzaz: {
    '1': '0-3家',
    '2': '3-6家',
    '3': '6-16家',
    '4': '大于 16 家',
  },
  xyp_t01cchzbc: {
    '1': '0-2家',
    '2': '2-6家',
    '3': '6-34家',
    '4': '大于 34 家',
  },
  xyp_t01cchzzc: {
    '1': '0-2家',
    '2': '2-44家',
    '3': '大于 44 家',
  },
  xyp_t01ccizza: {
    '1': '0-2家',
    '2': '2-3家',
    '3': '大于 3 家',
  },
  xyp_t01ccizzc: {
    '1': '0-2家',
    '2': '2-3家',
    '3': '3-5家',
    '4': '大于 5 家',
  },
  xyp_t01ccjzaz: {
    '1': '0-4家',
    '2': '4-6家',
    '3': '大于 6 家',
  },
  xyp_t01ccjzbc: {
    '1': '0-2家',
    '2': '2-9家',
    '3': '9-11家',
    '4': '11-15家',
    '5': '大于 15 家',
  },
  xyp_t01cckzaz: {
    '1': '0-3家',
    '2': '3-6家',
    '3': '6-11家',
    '4': '大于 11 家',
  },
  xyp_t01cckzzc: {
    '1': '0-2家',
    '2': '2-4家',
    '3': '4-16家',
    '4': '16-36家',
    '5': '大于 36 家',
  },
  xyp_t01cclzba: {
    '1': '0-2家',
    '2': '2-6家',
    '3': '6-14家',
    '4': '大于 14 家',
  },
  xyp_t01cclzbc: {
    '1': '0-2家',
    '2': '2-9家',
    '3': '9-14家',
    '4': '14-31家',
    '5': '31-50家',
    '6': '大于 50 家',
  },
  xyp_t01cclzzc: {
    '1': '0-2家',
    '2': '2-10家',
    '3': '10-36家',
    '4': '36-60家',
    '5': '大于 60 家',
  },
  xyp_t01cczzbc: {
    '1': '0-2家',
    '2': '2-9家',
    '3': '9-14家',
    '4': '14-27家',
    '5': '27-49家',
    '6': '大于 49 家',
  },
  xyp_t01cczzzz: {
    '1': '0-28家',
    '2': '28-44家',
    '3': '44-82家',
    '4': '大于 82 家',
  },
  xyp_t01defzbz: {
    '1': '0-2家',
    '2': '2-5家',
    '3': '5-13家',
    '4': '大于 13 家',
  },
  xyp_t01degzbc: {
    '1': '0-1家',
    '2': '1-5家',
    '3': '5-10家',
    '4': '大于 10 家',
  },
  xyp_t01degzzc: {
    '1': '0-1家',
    '2': '1-7家',
    '3': '7-11家',
    '4': '大于 11 家',
  },
  xyp_t01dejzbc: {
    '1': '0-1家',
    '2': '1-5家',
    '3': '5-8家',
    '4': '大于 8 家',
  },
  xyp_t01dejzbz: {
    '1': '0-1家',
    '2': '1-5家',
    '3': '5-8家',
    '4': '大于 8 家',
  },
  xyp_t01dejzzc: {
    '1': '0-2家',
    '2': '2-7家',
    '3': '7-9家',
    '4': '大于 9 家',
  },
  xyp_t01dekzbc: {
    '1': '0-1家',
    '2': '1-8家',
    '3': '8-12家',
    '4': '大于 12 家',
  },
  xyp_t01dekzzc: {
    '1': '0-2家',
    '2': '2-10家',
    '3': '10-14家',
    '4': '大于 14 家',
  },
  xyp_t01dekzzz: {
    '1': '0-11家',
    '2': '11-15家',
    '3': '大于 15 家',
  },
  xyp_t01delzbc: {
    '1': '0-1家',
    '2': '1-3家',
    '3': '3-8家',
    '4': '8-12家',
    '5': '大于 12 家',
  },
  xyp_t01delzzc: {
    '1': '0-2家',
    '2': '2-3家',
    '3': '3-11家',
    '4': '11-17家',
    '5': '大于 17 家',
  },
  xyp_t01aazfbc: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aazfzc: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aazfzz: {
    '1': '0-1000家',
    '2': '1000-2000家',
    '3': '大于 2000 家',
  },
  xyp_t01aazgzc: {
    '1': '0-400家',
    '2': '400-1000家',
    '3': '大于 1000 家',
  },
  xyp_t01aazhaz: {
    '1': '0-1000家',
    '2': '1000-3000家',
    '3': '大于 3000 家',
  },
  xyp_t01aazhbz: {
    '1': '0-1000家',
    '2': '1000-4800家',
    '3': '大于 4800 家',
  },
  xyp_t01aazhzc: {
    '1': '0-1000家',
    '2': '1000-4800家',
    '3': '大于 4800 家',
  },
  xyp_t01aazhzz: {
    '1': '0-1200家',
    '2': '1200-4800家',
    '3': '大于 4800 家',
  },
  xyp_t01abzfba: {
    '1': '0-200家',
    '2': '200-1300家',
    '3': '大于 1300 家',
  },
  xyp_t01abzfbz: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01abzfzc: {
    '1': '0-50家',
    '2': '50-450家',
    '3': '大于 450 家',
  },
  xyp_t01abzfzz: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01abzgza: {
    '1': '0-600家',
    '2': '600-1300家',
    '3': '大于 1300 家',
  },
  xyp_t01abzgzc: {
    '1': '0-50家',
    '2': '50-100家',
    '3': '大于 100 家',
  },
  xyp_t01aczezz: {
    '1': '0-1000家',
    '2': '1000-32000家',
    '3': '大于 32000 家',
  },
  xyp_t01aczfba: {
    '1': '0-3000家',
    '2': '3000-14000家',
    '3': '大于 14000 家',
  },
  xyp_t01aczfbc: {
    '1': '0-1000家',
    '2': '1000-31000家',
    '3': '大于 31000 家',
  },
  xyp_t01aczfbz: {
    '1': '0-6000家',
    '2': '6000-62000家',
    '3': '大于 62000 家',
  },
  xyp_t01aczfza: {
    '1': '0-3000家',
    '2': '3000-17000家',
    '3': '大于 17000 家',
  },
  xyp_t01aczfzc: {
    '1': '0-4000家',
    '2': '4000-50000家',
    '3': '大于 50000 家',
  },
  xyp_t01aczfzz: {
    '1': '0-6000家',
    '2': '6000-62000家',
    '3': '大于 62000 家',
  },
  xyp_t01aczgbc: {
    '1': '0-2000家',
    '2': '2000-36000家',
    '3': '大于 36000 家',
  },
  xyp_t01aczgbz: {
    '1': '0-12000家',
    '2': '12000-38000家',
    '3': '大于 38000 家',
  },
  xyp_t01aczgza: {
    '1': '0-1000家',
    '2': '1000-18000家',
    '3': '大于 18000 家',
  },
  xyp_t01aczgzc: {
    '1': '0-12000家',
    '2': '12000-50000家',
    '3': '大于 50000 家',
  },
  xyp_t01aczgzz: {
    '1': '0-12000家',
    '2': '12000-92000家',
    '3': '大于 92000 家',
  },
  xyp_t01aczhbc: {
    '1': '0-4000家',
    '2': '4000-42000家',
    '3': '大于 42000 家',
  },
  xyp_t01aczhzc: {
    '1': '0-4000家',
    '2': '4000-58000家',
    '3': '大于 58000 家',
  },
  xyp_t01adzfbz: {
    '1': '0-200家',
    '2': '200-1500家',
    '3': '大于 1500 家',
  },
  xyp_t01adzfzc: {
    '1': '0-500家',
    '2': '500-1800家',
    '3': '大于 1800 家',
  },
  xyp_t01adzgbc: {
    '1': '0-600家',
    '2': '600-1600家',
    '3': '大于 1600 家',
  },
  xyp_t01adzgzc: {
    '1': '0-600家',
    '2': '600-1700家',
    '3': '大于 1700 家',
  },
  xyp_t03td148: {
    '1': '0-1家',
    '2': '1-2家',
    '3': '2-3家',
    '4': '3家以上',
  },
}
